import { z } from './utils/zod.js';
import { dataResponse } from './utils/response-templates.js';
export const emailSettings = z.object({
    signerStarted: z.boolean(),
    signerCompleted: z.boolean(),
    signerSigned: z.boolean(),
    signingCompleted: z.boolean(),
    signingCanceled: z.boolean(),
    signingExpired: z.boolean(),
});
export const emailNotificationsDtoSchema = z.object({
    userId: z.string(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
    settings: emailSettings,
});
export const getEmailNotificationResponseSchema = dataResponse(emailNotificationsDtoSchema);
export const createEmailNotificationSchema = z.object({
    signerStarted: z.boolean().optional(),
    signerCompleted: z.boolean().optional(),
    signerSigned: z.boolean().optional(),
    signingCompleted: z.boolean().optional(),
    signingCanceled: z.boolean().optional(),
    signingExpired: z.boolean().optional(),
    signingCompletedNoDocs: z.boolean().optional(),
    billingAllowanceWarning: z.boolean().optional(),
    reviewApproved: z.boolean().optional(),
});
export const createEmailNotificationResponseSchema = dataResponse(emailNotificationsDtoSchema);
export var EmailNotificationType;
(function (EmailNotificationType) {
    EmailNotificationType["SIGNER_STARTED"] = "signerStarted";
    EmailNotificationType["SIGNER_COMPLETED"] = "signerCompleted";
    EmailNotificationType["SIGNER_SIGNED"] = "signerSigned";
    EmailNotificationType["SIGNING_COMPLETED"] = "signingCompleted";
    EmailNotificationType["SIGNING_CANCELED"] = "signingCanceled";
    EmailNotificationType["SIGNING_EXPIRED"] = "signingExpired";
    EmailNotificationType["SIGNING_COMPLETED_NO_DOCS"] = "signingCompletedNoDocs";
    EmailNotificationType["BILLING_ALLOWANCE_WARNING"] = "billingAllowanceWarning";
    EmailNotificationType["REVIEW_APPROVED"] = "reviewApproved";
})(EmailNotificationType || (EmailNotificationType = {}));
